/** Used to view layout of all placeholder modules */
export const DISPLAY_PLACEHOLDERS = false;

export enum PlaceHolderModuleName {
  DATA_URL_LOADER = 'placeholder-dataurl',
}
